import { formatDate } from "../../../../../util/time";

const canMatchAcrossModules = (addonKey) => addonKey === "users";

export const isScheduledRemovedChildAddon = ({
  moduleId,
  child,
  scheduledAddonChanges = [],
}) => {
  const childAddonKey = child?.addonKey;
  if (!childAddonKey) return false;

  return scheduledAddonChanges.some((addon) => {
    if (!addon?.isRemoving) return false;

    const addonKey = addon?.addonKey;
    if (childAddonKey !== addonKey) return false;

    if (canMatchAcrossModules(addonKey)) {
      return true;
    }

    return String(moduleId || "") === String(addon?.moduleId || "");
  });
};

export const getScheduledModuleChangeDate = ({
  plan,
  scheduledAddonChanges = [],
  summary,
}) => {
  const scheduledChangeDates = scheduledAddonChanges
    .map((addon) => (addon?.changeDate ? new Date(addon.changeDate) : null))
    .filter((date) => date && !Number.isNaN(date.getTime()))
    .sort((left, right) => left.getTime() - right.getTime());

  const nextBillingDate =
    scheduledChangeDates[0] ||
    plan?.scheduledDate ||
    summary?.nextBillDate ||
    summary?.nextChargeDate;

  if (!nextBillingDate) return null;

  const parsedDate = new Date(nextBillingDate);
  if (Number.isNaN(parsedDate.getTime())) return null;

  return formatDate(parsedDate, { month: "long" });
};
